var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[(_vm.item.isNegative)?_c('span',{staticClass:"red--text"},[_vm._v(_vm._s(_vm.item.agency_commissions))]):_c('span',[_vm._v(_vm._s(_vm.item.agency_commissions))])])])}
var staticRenderFns = []

export { render, staticRenderFns }